/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Address } from './address';

/**
 * Serializer for Organization model with all fields. Used for CRUD operations by directors.
 */
export interface Organization { 
    readonly id: string;
    /**
     * Oficiální název organizace
     */
    officialName: string;
    /**
     * IČO
     */
    lawId?: string;
    readonly address: Address;
    /**
     * RED_IZO = Resortní identifikátor právnické osoby vykonávající činnost školy
     */
    redIzo?: string;
    /**
     * Datová schránka
     */
    databox?: string;
    /**
     * Webová stránka
     */
    website?: string;
    /**
     * Indikuje, zda se jedná o testovací organizaci
     */
    isTestOrganization?: boolean;
    readonly created: Date;
    readonly modified: Date;
}